import http from "../http-common"


const newPurchase = (data) => {
    return http.post("/api/process" ,data);
}
const buyAgain = (id) => {
     return http.post("/api/process", id);
}

const checkStatus = ( id ) => {
    return http.post("/api/process", id);
}

const AirtimeTokenService = {
    newPurchase,
    buyAgain,
    checkStatus

};

export default AirtimeTokenService;